import {useEffect, useState} from "react";
import {Col, Empty, Layout, Row, Typography, Avatar, AspectRatio} from "tiny-ui";
import {Content} from "tiny-ui/lib/layout/layout";
import {CSSTransitionGroup} from 'react-transition-group'
import './transitions.css';
import useInterval from "./hooks/useInterval";

const APP_BASE = window.location.origin;
const API_BASE = APP_BASE + '/wp-json/order-status/v1/';

function StatusList({title, clr, cols, items}) {
  return (
    <Col span={cols} style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
      <Typography.Heading>{title}</Typography.Heading>
      <CSSTransitionGroup
        style={{
          display: 'flex',
          flexWrap: 'wrap',
          justifyContent: 'center',
          width: '100%',
          maxWidth: '1000px'
        }}
        transitionName="processing-transition"
        transitionEnterTimeout={500}
        transitionLeaveTimeout={300}>
        {!items.length ?
          <Empty description='Hier gibt es nichts zu sehen...'/> : items.map(({index}) => (
            <AspectRatio ratio={1} key={index} style={{flex: '0 0 33%', textAlign: 'center'}}>
              <Avatar className="number-avatar" style={{
                background: clr,
                width: '90%',
                height: '90%',
                margin: '5%',
                fontSize: '20vw',
              }}>{index + 1}</Avatar>
            </AspectRatio>
          ))}
      </CSSTransitionGroup>
    </Col>
  );
}

function App() {
  const [statuses, setStatuses] = useState([]);

  const loadStatuses = () => {
    fetch(API_BASE + "status")
      .then(res => res.json())
      .then(body => {
        setStatuses(body.statuses);
      });
  };

  useInterval(() => {
    loadStatuses();
  }, 3000);

  useEffect(() => {
    loadStatuses();
  }, []);

  return (
    <Layout>
      <Content>
        <Row>
          {/* <StatusList title="In Arbeit" clr="#ff9800" items={statuses.filter(({status}) => status === 'processing')}/> */}
          <StatusList title="Bereit zur Abholung" clr="#4caf50" cols={24}
                      items={statuses.filter(({status}) => status === 'ready')}/>
        </Row>
      </Content>
    </Layout>
  );
}

export default App;
